import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const vehiclesOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.VEHICLES,
    steps: [
        {
            id: "veh-welcome",
            title: "Gestão de Veículos",
            description:
                "Gerencie todos os veículos cadastrados na plataforma. Cada veículo está vinculado a um motorista.",
            position: "center",
        },
        {
            id: "veh-grid",
            title: "Lista de Veículos",
            description:
                "Veja marca, modelo, placa, ano e status de aprovação. Clique para editar qualquer veículo.",
            targetId: "vehicles-table",
            position: "bottom",
        },
        {
            id: "veh-add",
            title: "Adicionar Veículo",
            description:
                "Cadastre um novo veículo e vincule-o a um motorista existente.",
            targetId: "vehicles-add-btn",
            position: "left",
        },
        {
            id: "veh-status",
            title: "Aprovação de Veículos",
            description:
                "Veículos precisam de aprovação antes de poderem realizar corridas. Aprove ou rejeite nas ações da tabela.",
            targetId: "vehicles-actions",
            position: "left",
        },
    ],
};
